export interface AlertState {
  show: boolean;
  message?: string;
  alertType?: AlertType;
}

export const enum AlertAction {
  UpdateAlert = "UpdateAlert"
}

export const enum AlertMutation {
  SetShow = "SetShow",
  SetMessage = "SetMessage",
  SetAlertType = "SetAlertType "
}

export const enum AlertGetter {
  GetShow = "GetShow",
  GetMessage = "GetMessage",
  GetAlertType = "GetAlertType"
}

export enum AlertType {
  Info = "info",
  Success = "success",
  Danger = "danger"
}
